import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "./firebase"; // Import Firebase configuration
import { AuthProvider } from "./contexts/AuthContext"; // Import AuthProvider
import { ViewProvider } from "./contexts/ViewContext"; // Import ViewProvider

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ViewProvider>
          <App />
        </ViewProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Create a non-intrusive banner prompting the user to refresh
    const banner = document.createElement("div");
    banner.className =
      "fixed bottom-4 left-1/2 -translate-x-1/2 bg-blue-600 text-white font-medium px-4 py-2 rounded shadow-lg cursor-pointer z-50";
    banner.textContent =
      "A new version of MILA Care is available. Click to update.";

    banner.onclick = () => {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });

        let refreshing;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (refreshing) return;
          window.location.reload();
          refreshing = true;
        });
      }
    };

    document.body.appendChild(banner);
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
